import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#0077b6',
    },
    secondary: {
      main: '#E76F51',
    },
    error: {
      main: '#dc2f02',
    },
    warning: {
      main: '#f4a261',
    },
    success: {
      main: '#2a9d8f',
    },
    white: {
      main: '#F5F5F5',
    },
    offwhite: {
      main: '#F5F5F5',
    },
    offbeige: {
      main: '#F8F0E3',
    },
    black: {
      main: '#000000',
    },
  },
  overrides: {
    MuiAccordion: {
      root: {
        borderRadius: 0,
        '&&.Mui-expanded': {
          margin: '5px 0',
        },
        boxShadow: 'none',
      },
      rounded: {
        '&&:first-child': {
          borderRadius: 0,
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: '1.5px',
      },
      contained: {
        boxShadow: 'none',
      },
    },
    MuiCard: {
      root: {
        borderRadius: '2.5px',
      },
    },
    MuiInputBase: {
      root: {
        borderRadius: '1px',
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: '2.5px',
      },
    },
    MuiFab: {
      root: {
        boxShadow:
          'rgb(0 0 0 / 13%) 0px 3.2px 7.2px 0px, rgb(0 0 0 / 11%) 0px 0.6px 1.8px 0px',
      },
    },
    MuiFilledInput: {
      root: {
        borderTopLeftRadius: '2.5px',
        borderTopRightRadius: '2.5px',
      },
    },
    MuiPaper: {
      elevation1: {
        boxShadow:
          'rgb(0 0 0 / 13%) 0px 3.2px 7.2px 0px, rgb(0 0 0 / 11%) 0px 0.6px 1.8px 0px',
      },
    },
    MuiPopover: {
      paper: {
        borderRadius: '1px',
        boxShadow:
          'rgb(0 0 0 / 13%) 0px 3.2px 7.2px 0px, rgb(0 0 0 / 11%) 0px 0.6px 1.8px 0px',
      },
    },
    MuiSwitch: {
      root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: 8,
      },
      switchBase: {
        padding: 1,
        '&$checked, &$colorPrimary$checked, &$colorSecondary$checked': {
          transform: 'translateX(16px)',
          color: '#fff',
          '& + $track': {
            opacity: 1,
            border: 'none',
          },
        },
      },
      thumb: {
        width: 24,
        height: 24,
      },
      track: {
        borderRadius: 13,
        border: '1px solid #bdbdbd',
        backgroundColor: '#fafafa',
        opacity: 1,
        transition:
          'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: 'white',
        color: 'black',
        fontSize: '12px',
        boxShadow:
          'rgb(0 0 0 / 13%) 0px 3.2px 7.2px 0px, rgb(0 0 0 / 11%) 0px 0.6px 1.8px 0px',
        borderRadius: '1px',
      },
      arrow: {
        '&&:before': {
          backgroundColor: 'white',
          boxShadow: 'rgb(0 0 0 / 11%) 0px 0.6px 1.8px 0px',
        },
      },
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiTooltip: {
      arrow: true,
    },
  },
  typography: {
    fontFamily: 'Open Sans',
  },
});
